var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9905 1.83325C5.93051 1.83325 1.83301 5.93992 1.83301 10.9999C1.83301 16.0599 5.93051 20.1666 10.9905 20.1666C16.0597 20.1666 20.1663 16.0599 20.1663 10.9999C20.1663 5.93992 16.0597 1.83325 10.9905 1.83325ZM11.9163 11.9166V6.41658H10.083V11.9166H11.9163ZM11.9163 15.5833V13.7499H10.083V15.5833H11.9163ZM3.66634 10.9999C3.66634 15.0516 6.94801 18.3333 10.9997 18.3333C15.0513 18.3333 18.333 15.0516 18.333 10.9999C18.333 6.94825 15.0513 3.66659 10.9997 3.66659C6.94801 3.66659 3.66634 6.94825 3.66634 10.9999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutline);
export default __webpack_public_path__ + "static/media/error-outline.64c47859ad681e0f4462096599ba7693.svg";
export { ForwardRef as ReactComponent };